// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "@/api/index.js";
import "amfe-flexible";
import Vant from 'vant';
import 'vant/lib/index.css';
import "./directives/index.js";
import { Lazyload } from 'vant';
import i18n from "./i18n/i18n.js";

Vue.use(Lazyload);
Vue.use(Vant);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  data: function(){
    return {
      openId: '',
    }
  },
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js